import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.products.EditProductView.StepAccommodationSettings.accommodation_settings.category")}</h3>
    <p>
      {I18n.t("papp.products.EditProductView.StepAccommodationSettings.accommodation_settings.categoryDescription")}
    </p>

    <h3>{I18n.t("papp.products.EditProductView.StepAccommodationSettings.accommodationUnitSettings")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepAccommodationSettings.accommodationUnitSettingsDescription")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepAccommodationSettings.facilities")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepAccommodationSettings.facilitiesDescription")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAccommodationSettings/StepAccommodationSettingsHint.jsx